import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NgxSpinnerService} from 'ngx-spinner';
import {EventTypeService} from '../../../../core/services/eventType.service';
import {concatMap, from} from 'rxjs';
import {FrontUserService} from '../../../../core/services/frontUsers.service';

@Component({
  selector: 'app-creditCorrection-all',
  templateUrl: './credit-correction-all.component.html',
  styleUrls: ['./credit-correction-all.component.scss'],
  standalone: false
})

export class CreditCorrectionAllComponent implements OnInit {
  users;
  usersStr = '';
  result = [];
  selectedEventType;
  credits = 0;
  comment = '';
  errorResult = [];
  public eventCategories = [];
  updateFinished = false;
  constructor(public eventTypeService: EventTypeService, public dialogRef: MatDialogRef<CreditCorrectionAllComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, public spinner: NgxSpinnerService,
              private frontUserService: FrontUserService) {
    this.users = data;
    if (this.users.length) {
      this.users.forEach(el => {
        this.usersStr = this.usersStr + el.firstName + ' ' + el.lastName + ', ';
      });
    }
    this.usersStr = this.usersStr.substring(0, this.usersStr.length - 2);
  }

  ngOnInit() {
    this.getEventType();
  }

  getEventType() {
    this.eventTypeService.getEventTypes().then((result: any) => {
      this.eventCategories = result.map((res: any) => {
        return {label: res.name, value: res.id , color: res.color};
      });
    });
  }

  startCorrection() {

    if (this.users && this.users.length) {
      this.spinner.show();
      from(this.users)
        .pipe(
          concatMap((el: any, index): any => {
            let data: any = {
              eventTypeId: this.selectedEventType,
              credits: this.credits,
              type: 'custom',
              fronUserId: el.id,
              comment: this.comment
            };
            return this.frontUserService.addRewards(data);
          })
        )
        .subscribe({
          next: (res: any) => {
            if (res) {
              this.frontUserService.updateAllYearsRewards(res.frontUserId).subscribe();
            }
          },
            error: (err) => {
            this.errorResult.push(err);
          },
            complete: () => {
              this.spinner.hide();
              this.updateFinished = true;
          }
        });
    }
  }
}
